import { useState } from 'react';
// components
import {
  IEditForm,
  CasEditForm,
  CasRHFSwitch,
  CasRHFTextField,
  CasRHFPercentField,
  CasStackRow,
} from 'src/compass/shared/components';
import {
  CasAsOfContainer,
  CasAsOfMultiRowWithErrorDisplay,
  EntityInfoLRPSchedules,
  useDefaultAsOfValues,
} from 'src/compass/application/commissions';
import { CasRHFRiskManagerSelect } from 'src/compass/application/general/components/CasRiskManagerSelect';

// schema
import { LRPScheduleSchema } from './LRPScheduleSchema';

// ----------------------------------------------------------------------

export default function LRPSchedulesForm({ row, onSaved }: IEditForm) {
  const { id } = row || {};
  const editMode = !!id;

  const [asofReadonly, setAsofReadonly] = useState(false);

  const [isSplit, setIsSplit] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState();

  const defaultValues = useDefaultAsOfValues(row, { isActive: true });

  return (
    <CasEditForm
      defaultValues={defaultValues}
      onSaved={onSaved}
      entity={EntityInfoLRPSchedules.entity}
      schema={LRPScheduleSchema}
    >
      <CasStackRow>
        <CasRHFRiskManagerSelect
          name="servicingAgentId"
          label="Relationship Owner"
          onChange={(_, value) => setSelectedEmployee(value)}
          disabled={editMode}
        />

        <CasRHFSwitch
          name="isActive"
          label="Active"
          helperText="(When inactive, can remain on existing accounts, but can no longer be assigned to accounts.)"
        />
      </CasStackRow>
      <CasRHFTextField name="description" label="Description" />
      <CasAsOfContainer
        entityTitle='Schedule AsOf'
        entityId={id}
        deleteChildEntity="Ins/CommSchedule/AsOf"
        initialAsOfList={row?.asOfs}
        initialAsOf={defaultValues.asOf}
        readOnly={asofReadonly}
        setReadOnly={setAsofReadonly}
      >
        <CasRHFPercentField name="asOf.totalRatePercent" label="Rate" disabled={asofReadonly} />
        <CasRHFSwitch
          name="asOf.isSplit"
          label="Split with other agents?"
          disabled={asofReadonly}
          onChange={(_, value) => setIsSplit(value)}
        />

        {isSplit && (
          <CasAsOfMultiRowWithErrorDisplay
            readOnly={asofReadonly}
            name="asOf.asOfSplits"
            triggerValidationList={['asOf.asOfSplits', 'asOf.totalRatePercent', 'servicingAgentId']}
            row1Cell1={editMode ? row.servicingAgentId : selectedEmployee}
            rowCountMode={2}
            columns={[
              {
                type: 'component',
                label: 'Agent',
                name: 'agentId',
                fullWidth: true,
                component: CasRHFRiskManagerSelect,
              },
              {
                type: 'component',
                label: 'Rate',
                name: 'ratePercent',
                component: CasRHFPercentField,
              },
            ]}
          />
        )}
      </CasAsOfContainer>
    </CasEditForm>
  );
}
